"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveableOption = void 0;
var React = __importStar(require("react"));
var styles = __importStar(require("./styles.modules.css"));
var icon_1 = require("../icon");
var select_1 = require("./select");
var button_1 = require("../button");
var tag_1 = require("../tag");
var RemoveableOption = function (props) {
    var option = props.option, onRemove = props.onRemove;
    var _optionLabel = (0, select_1.optionLabel)(option);
    var label = (React.createElement(React.Fragment, null,
        _optionLabel,
        React.createElement(button_1.Button, { className: styles.remove, label: React.createElement(icon_1.Icon, { icon: icon_1.Icons.Cross }), action: function () {
                onRemove(option);
            } })));
    return React.createElement(tag_1.Tag, { label: label, className: styles.selectedOption });
};
exports.RemoveableOption = RemoveableOption;
exports.default = RemoveableOption;
//# sourceMappingURL=removeable-option.js.map